import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse } from '@angular/common/http';
import { wsPayloadResponse } from './payload';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PlugpointEnvironment } from '../PlugpointEnvironment';
import { Guid } from 'guid-typescript';
import { User } from './user';
import { AutoChargeData, PendingVid, AutoChargeWallet } from './vids';


const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' , 'SessionID': Guid.create().toString() })
};

@Injectable()
export class UserService {
  private url :string = '';
  private token = Guid.create().toString();
  public guid = true;
  constructor(
    public http: HttpClient,
  ) {
    this.url = PlugpointEnvironment.endpoint;
  }
  /*
        * gateway done
  */
  async recordIssue(data: any, environment: string)  {
        return this.http.post(PlugpointEnvironment.url + `/helios/support/${environment}/support-issue`, data, httpOptions).pipe(
            map(() => true),
            catchError(() => of(false))
        ).toPromise();
  }
 /*
        * gateway done
  */
  getCategories(environment: string) {

    return this.http.get(PlugpointEnvironment.url + `/helios/support/${environment}/issue-categories`, httpOptions);
  }


    getCategoriesForPos() {

        return this.http.get(PlugpointEnvironment.url + `/pos-central/dashboard/support-issue-categories`, httpOptions);
    }

    async recordIssuePos(data: any): Promise<boolean> {

         return this.http.post(PlugpointEnvironment.url + `/pos-central/dashboard/support-issue`, data, httpOptions).pipe(
            map(() => true),
            catchError(() => of(false))
        ).toPromise();
    }

    /*
        * skip
    */
    async cancelSession(posId: string, sessionId: string): Promise<boolean> {
           return this.http.post(PlugpointEnvironment.url + `/pos-central/${posId}/session/${sessionId}/end`, {}, httpOptions).pipe(
            map(() => true),
            catchError(() => of(false))
        ).toPromise();
    }


  updateUserPhoneNumber(userId: string, phoneNumber: string): Observable<any> {
    const url = `${PlugpointEnvironment.url}/gateway/api/user/updatePhoneNumber`;
    const body = { userId, phoneNumber };


    return this.http.put<wsPayloadResponse>(url, body, httpOptions).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Gateway error:', error.status, error.message);
        throw error;
      })
    );
  }

  /**
   * Get user data from gateway API using JWT token
   * This is the NEW method for authenticated gateway calls
   * Returns User object directly (not base64 encoded)
   * Returns empty/null fields if user not found (NO_DATA) - caller should call addUserToWs
   */
  getUserDataFromGateway(username: string): Observable<User | null> {
    const url = `${PlugpointEnvironment.url}/gateway/api/user/data`;
    const body = {
      info: {
        userName: username,
        version: 'latest'
      }
    };

    return this.http.post<User | null>(url, body, httpOptions).pipe(
      catchError((error: HttpErrorResponse) => {
        // Re-throw HTTP errors (502 Bad Gateway, etc.)
        console.error('Gateway error:', error.status, error.message);
        throw error;
      })
    );
  }

  /**
   * @deprecated Use getUserDataFromGateway with JWT token instead
   * Legacy method - kept for backward compatibility during migration
   */
  getUserData(username: string): Observable<wsPayloadResponse> {
    if(this.guid == true){
      this.token = Guid.create().toString();
    }
    let data = {
      "getUserInfo": {
        "userName": username
      }
    }
    var encodedData = btoa(JSON.stringify(data));
    let body = {
      "token": this.token,
      "action": "usersData",
      "data": encodedData
    }
    return this.http.post<wsPayloadResponse>(this.url, body, httpOptions);
  }
  getAllUsersData(): Observable<{ data :string } | null> {
    const url = `${PlugpointEnvironment.url}/gateway/api/user/data/all/v2`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.get<{ data: string } | null>(url, httpOptions).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Gateway error:', error.status, error.message);
        throw error;
      })
    );
  }
  /*
      * check to see whats returned
      * skip
  */
  getAllBlockedUsers():Observable<wsPayloadResponse> {
    let body = {
      "token" : this.token,
      "action" : "blockedList",
      "data": "ewogICAgICAgICJnZXRCbG9ja2VkIiA6IHsKICAgICAgICAgICAgInBob25lTnVtYmVyIiA6ICJhbGwiCiAgICAgICAgfQogICAgfQ=="
  }
    return this.http.post<wsPayloadResponse>(this.url,body,httpOptions)
  }

  /*
   * skip
    */
  unblockUserByIp(ip: string, phone:string): Observable<wsPayloadResponse>{
    if(this.guid == true){
      this.token = Guid.create().toString();
      }
    let data = {
        "updateBlocked" : {
            "phoneNumber" : phone,
            "ip" : ip,
            "unblock" : "ip"
        }
    }
    var encodedData = btoa(JSON.stringify(data));
    let body =
      {
        "token" : this.token,
        "action" : "blockedList",
        "data": encodedData
    }
    return this.http.post<wsPayloadResponse>(this.url,body,httpOptions)
  }
  //skip
  unblockUserByPhone(ip: string, phone:string): Observable<wsPayloadResponse>{
    if(this.guid == true){
      this.token = Guid.create().toString();
      }
    let data = {
        "updateBlocked" : {
            "phoneNumber" : phone,
            "ip" : ip,
            "unblock" : "phone"
        }
    }
    var encodedData = btoa(JSON.stringify(data));
    let body =
      {
        "token" : this.token,
        "action" : "blockedList",
        "data": encodedData
    }
    return this.http.post<wsPayloadResponse>(this.url,body,httpOptions)
  }
  //skip

  getScenarioStatus(): Observable<wsPayloadResponse> {
    if(this.guid == true){
      this.token = Guid.create().toString();
      }
    let data = {
        "getScenario" : {
            "scenario" : "smsFlood"
        }
    }
    var encodedData = btoa(JSON.stringify(data));
    let body = {
      "token" : this.token,
      "action" : "scenariosTable",
      "data": encodedData
    }
    return this.http.post<wsPayloadResponse>(this.url,body,httpOptions)
  }
  //skip

  changeScenario(active: boolean): Observable<wsPayloadResponse> {
    if(this.guid == true){
      this.token = Guid.create().toString();
      }
    let data = {
        "updateScenario" : {
            "scenario" : "smsFlood",
            "active" : active
        }
    }
    let encodedData = btoa(JSON.stringify(data));
    let body = {
      "token" : this.token,
      "action" : "scenariosTable",
      "data": encodedData
    }
    return this.http.post<wsPayloadResponse>(this.url,body,httpOptions)
  }
  getInvoiceAndSimpleAccountByInvoiceNumber(invoiceName: string) {
    const url = `${PlugpointEnvironment.url}/gateway/api/account/invoice-number/${invoiceName}`;
    return this.http.get<any>(url, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        SessionID: Guid.create().toString()
      })
    });
  }
  /*
      * skip
  */
  getEncryptData(username: string): Observable<wsPayloadResponse> {
    if(this.guid == true){
      this.token = Guid.create().toString();
      }
    let data = {
      "cardRedirect": {
        "userName": username
      }
    }
    var encodedData = btoa(JSON.stringify(data));
    let body = {
      "token": this.token,
      "action": "payData",
      "data": encodedData
    }
    //console.log("body for getEncryptData is: " + JSON.stringify(body));
    return this.http.post<wsPayloadResponse>(this.url, body, httpOptions);
  }

    setUserData(data: any, token: string): Observable<User | null> {
        const url = `${PlugpointEnvironment.url}/gateway/api/user/data/update`;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });
        const body = { update:  data };

        return this.http.put<User | null>(url, body, { headers }).pipe(
            catchError((error: HttpErrorResponse) => {
                console.error('Gateway error:', error.status, error.message);
                throw error;
            })
        );

    }
  // blockUser(): Observable<wsPayloadResponse> {
  //   let body = {
  //     "blocked" : true

  //   }
  //   return this.http.post<wsPayloadResponse>(this.url,body,httpOptions)
  // }

  /*
      * not used
  */
  setFavouriteStation(command: string, userName: string, stationId: string): Observable<wsPayloadResponse> {
    if(this.guid == true){
      this.token = Guid.create().toString();
      }
    let data = {
      "favorites": {
        "userName": userName,
        "command": command,
        "stationId": stationId
      }
    }
    var encodedData = btoa(JSON.stringify(data));

    let body = {
      "token": this.token,
      "action": "usersData",
      "data": encodedData
    }
    //console.log("body for addUserToWs is: " + JSON.stringify(body));
    return this.http.post<wsPayloadResponse>(this.url, body, httpOptions);
  }

    addUserToWs(userEmail: string, userName: string, token: string): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/user/add`;

        const body = {
                userEmail: userEmail,
                userName: userName,
                stationVendor: "",
                generalNotifications: true,
                appUpdates: true,
                showOnLockScreen: true,
                emailGeneralNotifications: true,
                monthlyNewsletter: true,
                promoOffers: true,
                carType: "999",
                notificationId: "",
                role: "guest",
                access: "",
                type: "none"
        }

        // Create headers with Authorization token for gateway API
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'SessionID': Guid.create().toString(),
            'Authorization': 'Bearer ' + token
        });

        return this.http.post<any>(url, body, { headers });
    }

    /*
        * not used
    */
  getCarsData(): Observable<wsPayloadResponse> {
    if(this.guid == true){
      this.token = Guid.create().toString();
      }
    let data = {
      "getCars": {
        "cars": "all"
      }
    }
    var encodedData = btoa(JSON.stringify(data));
    let body = {
      "token": this.token,
      "action": "carsData",
      "data": encodedData
    }
    //console.log("body for getCarsData is: " + JSON.stringify(body));
    return this.http.post<wsPayloadResponse>(this.url, body, httpOptions);
  }

  /*
      * not used
  */
  setVendor(userEmail: string, stationVendor: string): Observable<wsPayloadResponse> {
    if(this.guid == true){
      this.token = Guid.create().toString();
      }
    let data = {
      "updateVendor": {
        "userEmail": userEmail,
        "stationVendor": stationVendor
      }
    }
    var encodedData = btoa(JSON.stringify(data));
    let body = {
      "token": this.token,
      "action": "usersData",
      "data": encodedData
    }
    //console.log("body for getUserPayData is: " + JSON.stringify(body));
    return this.http.post<wsPayloadResponse>(this.url, body, httpOptions);
  }

  /*
      * legacy
  */
  getUserPayData(userName: string): Observable<wsPayloadResponse> {
    if(this.guid == true){
      this.token = Guid.create().toString();
      }
    let data = {
      "userPayData": {
        "userName": userName
      }
    }
    var encodedData = btoa(JSON.stringify(data));
    let body = {
      "token": this.token,
      "action": "payData",
      "data": encodedData
    }
    //console.log("body for getUserPayData is: " + JSON.stringify(body));
    return this.http.post<wsPayloadResponse>(this.url, body, httpOptions);
  }

  /*
      * legacy
  */
  setDefaultCard(usersPayDataId: number): Observable<wsPayloadResponse> {
    if(this.guid == true){
      this.token = Guid.create().toString();
      }
    let data = {
      "updatePayData": {
        "usersPayDataId": usersPayDataId,
        "defaultCard": true
      }
    }
    var encodedData = btoa(JSON.stringify(data));
    let body = {
      "token": this.token,
      "action": "payData",
      "data": encodedData
    }
    //console.log("body for setDefaultCard is: " + JSON.stringify(body));
    return this.http.post<wsPayloadResponse>(this.url, body, httpOptions);
  }

  getUserPayHistory(userName: string): Observable<wsPayloadResponse> {
    if(this.guid == true){
      this.token = Guid.create().toString();
      }
    let data = {
      "payHistory": {
        "userName": userName
      }
    }
    let body = {
      "token": this.token,
      "action": "payData",
      "data": data
    }
    //console.log("body for getUserPayHistory is: " + JSON.stringify(body));
    return this.http.post<wsPayloadResponse>(this.url + '/payData/payHistory', body, httpOptions);
  }

  //skip
  deleteUserCardData(usersPayDataId: number): Observable<wsPayloadResponse> {
    if(this.guid == true){
      this.token = Guid.create().toString();
      }
    let data = {
      "deletePayData": {
        "usersPayDataId": usersPayDataId
      }
    }
    let body = {
      "token": this.token,
      "action": "payData",
      "data": data
    }
    //console.log("body for deleteUserCardData is: " + JSON.stringify(body));
    return this.http.post<wsPayloadResponse>(this.url, body, httpOptions);
  }
//skip
  getAllInvoices(user?: string): Observable<wsPayloadResponse> {
    if(this.guid == true){
      this.token = Guid.create().toString();
      }
    if(!user) {
      user = "all";
    }
    let data = {
      "getInvoices": {
        "getInvoices": user
      }
    }
    var encodedData = btoa(JSON.stringify(data));
    let body = {
      "token": this.token,
      "action": "invoiceData",
      "data": encodedData
    }
    return this.http.post<wsPayloadResponse>(this.url, body, httpOptions);
  }
  //skip
  getOneInvoices(transactionId: string): Observable<wsPayloadResponse> {
    if(this.guid == true){
      this.token = Guid.create().toString();
      }

    let data = {
      "getInvoices": {
        "transactionId": transactionId
      }
    }
    var encodedData = btoa(JSON.stringify(data));
    let body = {
      "token": this.token,
      "action": "invoiceData",
      "data": encodedData
    }
    return this.http.post<wsPayloadResponse>(this.url, body, httpOptions);
  }



    getVendorInvoices(vendor: string, startDate: string, endDate: string, token: string): Observable<any> {
        const url = `${PlugpointEnvironment.url}/gateway/api/fleet/vendor/invoices`;
        const headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });
        const body = {
            vendorName: vendor,
            startDate: startDate,
            endDate: endDate
        };

        return this.http.post<any>(url, body, { headers })
    }

//skip
  payDebt(userName: string): Observable<wsPayloadResponse> {
    if(this.guid == true){
      this.token = Guid.create().toString();
      }
    let data = {
      "userPayDebt": {
        "userName": userName
      }
    }
    var encodedData = btoa(JSON.stringify(data));
    let body = {
      "token": this.token,
      "action": "payData",
      "data": encodedData
    }
    return this.http.post<wsPayloadResponse>(this.url, body, httpOptions);
  }
//skip
  getCardRegisterData(username: string, cif: string, companyName: string, fullName: string): Observable<wsPayloadResponse> {
    if(this.guid == true){
      this.token = Guid.create().toString();
      }
    let data = {
      "cardRegister": {
        "userName": username,
        "CIF": cif,
        "companyName": companyName,
        "fullName": fullName
      }
    }
    var encodedData = btoa(JSON.stringify(data));
    let body = {
      "token": this.token,
      "action": "payData",
      "data": encodedData
    }
    return this.http.post<wsPayloadResponse>(this.url, body, httpOptions);
  }
  // vid actions
    getAutoChargeData(userName: string): Observable<AutoChargeData> {
        return this.http.get<AutoChargeData>(PlugpointEnvironment.url + `/user/${userName}/autocharge`);
    }
    getPendingVids(userName: string): Observable<PendingVid[]> {
        return this.http.get<any[]>(PlugpointEnvironment.url + `/user/${userName}/vids`);
    }
    toggleAutoChargeStatus(userName: string, vid: string, enable: 'ACTIVE' | 'INACTIVE'): Observable<any> {
        return this.http.patch<any>(PlugpointEnvironment.url + `/user/${userName}/vids/${vid}/status`, { status: enable }, httpOptions);
    }
    editWallet(userName: string, vid: string, walletId: string): Observable<any> {
        return this.http.patch<any>(PlugpointEnvironment.url + `/user/${userName}/vids/${vid}/wallet`, { walletId: walletId }, httpOptions);
    }
    unlinkVid(userName: string, vid: string): Observable<any> {
        return this.http.patch<any>(PlugpointEnvironment.url + `/user/${userName}/vids/${vid}/unlink`, httpOptions);
    }
    activateVid(userName: string, vid: string, walletId: string): Observable<any> {
        return this.http.post<any>(PlugpointEnvironment.url + `/user/${userName}/vids/${vid}/activate`, { walletId: walletId }, httpOptions);
    }
    adminAdd(userName: string, vid: string, walletId: string): Observable<any> {
        return this.http.post<any>(PlugpointEnvironment.url + `/user/${userName}/vids/${vid}`, {walletId: walletId}, httpOptions);
    }
    getAutoChargeWallets(userName: string): Observable<AutoChargeWallet[]> {
        return this.http.get<AutoChargeWallet[]>(PlugpointEnvironment.url + `/gateway/api/wallet-info/user/${userName}/autocharge`, { headers: { sessionid: Guid.create().toString() } });
    }




  /**
 * Handle Http operation that failed.
 * Let the app continue.
 * @param operation - name of the operation that failed
 * @param result - optional value to return as the observable result
 */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      // console.error(error); // log to console instead


      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}



@Injectable()
export class NoCacheHeadersInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const authReq = req.clone({
      setHeaders: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache'
      }
    });
    return next.handle(authReq);
  }
}
